import { render, staticRenderFns } from "./jak-handlowac-kontraktami-futures.md?vue&type=template&id=ede1984c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports